import { html } from 'lit';
import { Lock } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-lock')
export class PdsIconLock extends PdsIcon {
  @state()
  icon = Lock;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
